<template>
  <div class="partners-unique">
    <div class="partners-bg-unique">
      <el-row>
        <el-col :span="24">
          <div class="tilBig-unique">战略合作伙伴</div>
          <p class="description-unique">
            <span class="desc-span-unique">2014年成立至今，华软科技股份有限公司在</span>
            <span class="desc-span-bold-unique">电力行业、能源、公共安全、轨道交通、边海防、矿业、环保、港口、基础建设</span>
            <span class="desc-span-unique">等领域，提供以</span>
            <span class="desc-span-bold-unique">无人化、集群化、智能化</span>
            <span class="desc-span-unique">为核心的专业化解决方案。</span>
          </p>
        </el-col>

      </el-row>
      <img src="@/assets/home/parterNew.png"  style="width: 100%; height: auto;"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partners',
  data() {
    return {
      parterBg: require('../../assets/home/parter.png') // 添加背景图片引用
    }
  }
}
</script>

<style lang="scss" scoped>
.tilBig-unique {
  font-family: PingFang SC;
  font-size: 32PX;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
  color: #1E242A;
  text-align: center;
}

.partners-unique {
  width: 100%;
  // max-width: 1920PX;

  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url('../../assets/home/parterBg.png');
    // background-image: url('../../assets/home/paterImg.png'); 
  /* 设置背景图片 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  // height: 692PX;
  padding: 80px 0px;
  /* 根据1920分辨率设置高度 */
  /* padding: 0PX 18.75%; */

  .partners-bg-unique {
    width: 1200px;
    margin: 0 auto;
    // display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.description-unique {
  font-size: 20PX;
  color: #1E242A;
  line-height: 1.8;
  margin: 20PX 0;
  text-align: center;
  // max-width: 400PX;
}

.desc-span-unique {
  /* 可根据需要添加通用样式 */
  color: #1E242A;
  opacity: 0.8;
}

.desc-span-bold-unique {
  font-weight: bold;
  color: #1E242A;
  // opacity: 0.8;
}

.hexagon-grid-unique {
  width: 748PX;
  /* 设置宽度为748PX */
  height: 531PX;
  /* 设置高度为531PX */
  background-image: url('../../assets/home/parter.png');
  /* 背景图片 */
  background-size: cover;
  /* 确保图片完全覆盖 */
  background-position: center;
  background-repeat: no-repeat;

  /* 居中显示 */
}
</style>
